import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import BasicText from '../../Theme/Fonts/BasicText'

export type GalleryPageCounterProps = {
    currentPage: number
    maxPages: number
}

const GalleryPageCounter: FunctionComponent<GalleryPageCounterProps> = ({
    currentPage,
    maxPages,
}): ReactElement => {
    return (
        <Grid horizontal noExpand>
            <Grid
                noExpand
                borderRadius={8}
                backgroundColor="onyx-opacity-50"
                paddingY={2}
                paddingX={3}
            >
                <BasicText
                    color="WHITE"
                    fontSize={['FS12', 'FS12', 'FS16']}
                    lineHeight={['LH16', 'LH16', 'LH20']}
                >{`${currentPage}/${maxPages}`}</BasicText>
            </Grid>
        </Grid>
    )
}

export default memo(GalleryPageCounter)
